export * from './colors';

export const typography = {
  titles: {
    fontWeight: '700',
    fontSize: '30px',
    lineHeight: '38px',
    paddingBottom: '0',
  },
  descriptionText: {
    fontSize: '16px',
    lineHeight: '22px',
  },
};

export const fonts = {
  primary: 'Circular Pro, sans-serif;',
};

export const values = {
  TIMEOUT_DELAY: 0.4,
  MESSAGE_TIMEOUT: 6000,
};
